// extracted by mini-css-extract-plugin
export default {"container":"Up-z","brandName":"Vp-z","productName":"Wp-z","productNamePdpEnhancements":"Xp-z","breakLongProductName":"Yp-z"};